import Vue from 'vue'
export default {
  key: function (len) {
    if (typeof len === 'undefined') {
      len = 10
    }
    let randKey = [...Array(len)].map( (i) => {
      return Math.floor((Math.random()*36)).toString(36)
    }).join('')
    return randKey
  },
  dig: function (ob, path, defaultValue) {
    let def = typeof defaultValue !== 'undefined' ? defaultValue : false
    if(!ob || typeof ob === 'undefined'){
      return def
    }
    let part = path.shift()
    if (path.length > 0) {
      if (typeof ob[part] !== 'undefined') {
        return this.dig(ob[part], path, def)
      } else {
        return def
      }
    } else if (typeof ob[part] !== 'undefined') {
        return ob[part]
    } else {
        return def
    }
  },
  getPropertyByPath: function (obj, path, defaultValue) {
    return this.dig(obj, path.split('.'), defaultValue)
  },
  setPropertyByPath: function (ob, path, value) {
    let parts = path.split('.')
    let part = parts.shift()
    if (parts.length > 0) {
      if (typeof ob[part] !== 'undefined') {
        return this.setPropertyByPath(ob[part], parts.join('.'), value)
      } else {
        return false
      }
    } else if (typeof ob[part] !== 'undefined') {
      Vue.set(ob, part, value)
    } else {
      Vue.set(ob, part, value)
      return false
    }
  },
  basename: function (value){
    return value.match(/.+\/(.+)$/)[1]
  },
  truncate: function (value, options) {
    let opts = Object.assign({length: 10, preserveEnds: false}, options)
    if (value.length <= opts.length) {
      return value
    }
    if(!opts.preserveEnds){
      return value.substr(0, length)
    }
    let cap = Math.floor(opts.length / 2)
    let start = value.substr(0, cap)
    let end = value.substr(-cap)

    return `${start}...${end}`
  },
  getIndexOfObject: function (arr, prop, value) {
    let idx = 0
    let found = false
    for(let ob of arr){
      if (ob[prop] === value){
        found = true
        break
      }
      idx++
    }
    return found && idx
  },
  filterObjectArray: function(arr, prop, value) {
    return arr.filter(item => { item[prop] === value})
  },
  any: function (array) {
    return array.length > 0
  },
  inflect (number, singular, plural) {
    if (number === 0) {
      return plural
    }
    if (number === 1) {
      return singular
    } else 
    {
      return plural
    }
  },
  capitalize (word) {
    try {
    const first = word.charAt(0)
    const rest = word.slice(1)
    return first.toUpperCase() + rest
    } catch (e) {
      return word
    }
  }
}